<template>
  <div class="products-categroy bg-center" :style="scanCodeStyle">
    <div id="productscg-charts" :style="scanCodeStyle"></div>
<!-- 	<dl id="effect-box">
		<dt></dt>
		<dd></dd>
	</dl> -->
    <div class="left-bg-title bg-center pd10tb">
		<img src="../../assets/images/icon1.png" class="icon"/>
		产品分类统计
	</div>
  </div>
</template>

<script>
//引入产品分类饼图需要的静态数据,
// import productsCg from "../../assets/staticData/productsCategroy";
import {getDataCategory} from "../../api/region.js";
import {mapState} from "vuex";
import $ from 'jquery'
export default {
  data(){
	  return {
		  productsData:{
			 legendData:[],
			 seriesData:[]
		  },
		  color: ["#FB497C",
		          "#FFC760",
		          "#6FE621",
		          "#4FCCFF",
		          "#3263E4",
		  		"#214E9F",
		  		"#59219f",
		  		"#80219f",
		  		"#9f2198",
		  		"#9f2168"
		  		],
				count:0,
				timer:null,
				Dom:null
	  }
  },	
  watch:{
	async syEnterpriseList(val)
	{
		let result = '';
		let data = ''
		await val.forEach((item,index) => {
			if(index == val.length-1)
			{
				result += 'orgList=' + item.org_id
			}
			else
			{
				result += 'orgList=' + item.org_id + '&'
			}
		})
		await getDataCategory(result).then(res => {
			data = res.data;
			if(data != '')
			{
				data.forEach(item => {
					this.productsData.legendData.push(item.c_name)
					this.productsData.seriesData.push({
						value:item.count,
						name:item.c_name
					})
					this.count += item.count;
				})
			}
		})
		//if(typeof this.Dom != 'null')
		//{
			this.setTime();
		//}
		
		//await this.seteffect();
	}  
  },
  
  mounted:function(){
  	this.Dom = document.getElementById("productscg-charts");
  },
  
  computed: {
	...mapState(['syEnterpriseList']),
    //提取公共样式,
    scanCodeStyle() {
      return this.$store.state.leftAreaChartsStyle;
    }
  },
  methods: {
    prodcgDrawLine() {
	  let that = this;
      //初始化echarts实例,
      let prodDom = that.Dom;
	  const prodcgChart = this.$echarts.init(prodDom);  
	  prodcgChart.clear()
      let option = {
		animationDuration: 3000,
        tooltip: {
          trigger: "item",
		  show:false,
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: this.productsData.legendData,
          textStyle: {
            color: that.color
          },
          left: '30',
          top: '18%'
        },
        series: [
          {
            name: "products",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
			left:'40%',
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.productsData.seriesData,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = that.color;
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      };
     prodcgChart.setOption(option);
    },
	setTime() {
		let nowTime = new Date();
		let that = this;
		that.prodcgDrawLine();
		this.clearTimer();
		this.timer = setTimeout(function() {
			if(new Date() - nowTime > 800)
			{
				that.setTime()
			}
		}, 6000);
	},
	//清除定时
	clearTimer()
	{
		clearInterval(this.timer);
		this.timer = null;
	}
  }
};
</script>

<style lang='less'>
.products-categroy {
  margin-top: 15px;
  position: relative;
  background-image: url("../../assets/images/products-info.png");
}
.left-bg-title{
background: none;
    line-height: 20px;
    left: 10px;
    top: 7px;
    color: #4FCCFF;
    width: auto;
    min-width: auto;
    max-width: 130px;
}
.left-bg-title .icon{
	width: 20px;
	height: 20px;
	float: left;
	margin-right: 8px;
}
#effect-box{
	position: absolute;
	left: 0px;
	top: 0px;
	width: 540px;
	height: 200px;
}
#effect-box dt{
text-align: right;
margin: 76px 146px 0px 0px;

}
#effect-box dd{
text-align: right;
margin: 7px 148px 0px 0px;
}
</style>